import { z } from 'zod';
import { match } from 'variant';
import { getGenerateFlowByKey } from './generateFlows.js';

// Extension type name as it stated in docs.
// This is the main entry point of the user for extension generation.
export const docsExtensionTypeSchema = z.enum([
  'DASHBOARD_PAGE',
  'DASHBOARD_MODAL',
  'DASHBOARD_PLUGIN',
  'DASHBOARD_MENU_PLUGIN',
  'EMBEDDED_SCRIPT',
  'CUSTOM_ELEMENT',
  'SITE_PLUGIN',
  'EVENT',
  'SERVICE_PLUGIN',
]);

export type DocsExtensionType = z.infer<typeof docsExtensionTypeSchema>;

export const getGenerateFlowByDocsExtensionType = (type: DocsExtensionType) => {
  return match(type, {
    DASHBOARD_PAGE: () => getGenerateFlowByKey('DashboardPage'),
    DASHBOARD_MODAL: () => getGenerateFlowByKey('DashboardModal'),
    DASHBOARD_PLUGIN: () => getGenerateFlowByKey('DashboardPlugin'),
    DASHBOARD_MENU_PLUGIN: () => getGenerateFlowByKey('DashboardMenuPlugin'),
    EMBEDDED_SCRIPT: () => getGenerateFlowByKey('EmbeddedScript'),
    CUSTOM_ELEMENT: () => getGenerateFlowByKey('CustomElement'),
    SITE_PLUGIN: () => getGenerateFlowByKey('SitePlugin'),
    EVENT: () => getGenerateFlowByKey('Event'),
    SERVICE_PLUGIN: () => getGenerateFlowByKey('ServicePlugin'),
  });
};
